///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.grx_cm = abcsetup.dashboard.grx_cm || {};

abcsetup.dashboard.grx_cm.rfq = abcsetup.dashboard.grx_cm.rfq || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.grx_cm = {
    init: function () {
        // RFQ Event delete button clicked
        $(document).on('click', '.btn-pause', function () {
            var btn = $(this);
            $('.tooltips, .btn[title]').tooltip('hide');

            // The current event is already paused
            if ($(this).html().indexOf('play') > -1) {
                abcsetup.dashboard.grx_cm.rfq.pauseEvent(btn.data('id'));

                // Confirm and get reason to pause the event
            } else {
                abcsetup.alerts.prompt('Pause RFQ Bid Event', 'Please specify a reason to pause this event:', function (resp) {
                    if (resp[0] == true) {
                        abcsetup.dashboard.grx_cm.rfq.pauseEvent(btn.data('id'), resp[1]);
                    }
                }, true);
            }

            return false;
        });

        // RFQ Event delete button clicked
        $(document).on('click', '.rfq_events_tables .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.prompt('Delete RFQ Bid Event', 'Please specify a reason to delete this event:', function (resp) {
                if (resp[0] == true) {
                    abcsetup.dashboard.grx_cm.rfq.deleteEvent(_this.data('id'), resp[1]);
                }
            }, true);

            return false;
        });

        // RFQ Event delete button clicked
        $(document).on('click', '#rfq_events .btn-restore', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete RFQ Event', 'Are you sure you want to restore this event?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.grx_cm.rfq.deleteEvent(_this.data('id'));
                }
            });

            return false;
        });

        $(document).on('click', '.js-btn-quick-resolve', function (e) {
            let _this = $(this);

            abcsetup.alerts.confirm('Quick Resolve this Supply Issue?', 'Would you like to mark this supply issue as resolved?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.grx_cm.rfq.quickResolve(_this.data('id'));
                }
            });
        })

        // RFQ - Send batch emails button clicked
        $('#rfq-batch-email-modal').on('show.bs.modal', function () {
            $('#bid-recipients tbody').empty();
        
            var headerRow = $("<tr>");
            headerRow.append($("<th>").append($("<input>").attr("type", "checkbox").attr("id", "check-all")));
            headerRow.append($("<th>").text("ID"));
            headerRow.append($("<th>").text("Name"));
            $("#bid-recipients thead").empty().append(headerRow);
        
            $("#check-all").on('change', function() {
                var isChecked = $(this).is(':checked');
                $('#bid-recipients tbody input[type="checkbox"]').prop('checked', isChecked);
            });
        
            $.get('/api/rfq/bid_requests/get_batch_email_recipients', function (data) {
                $.each(data, function(index, dataObject) {
                    var row = $("<tr>");
                    var keysToAppend = ['id', 'name'];
        
                    row.append($("<td>").append($("<input>").attr("type", "checkbox").attr("name", "ids[]").val(dataObject.id)));
                    
                    $.each(keysToAppend, function(_, key) {
                        row.append($("<td>").text(dataObject[key]));
                    });
        
                    $("#bid-recipients tbody").append(row);
                });
        
                // Check if no values were appended
                if ($("#bid-recipients tbody tr").length === 0) {
                    var emptyRow = $("<tr>").append($("<td colspan='3' style='text-align: center;'>").text("No bids available."));
                    $("#bid-recipients tbody").append(emptyRow);
                }
            });
        });

        $("#send-batch-emails").on('click', function() {
            // Get an array of checked checkbox values (IDs)
            var ids = $('input[name="ids[]"]:checked').map(function(){
                return $(this).val();
            }).get();
    
            // Send the selected IDs to the Laravel controller using AJAX
            $.ajax({
                type: 'GET',
                url: '/api/rfq/bid_requests/send_batch_emails',
                data: {
                    ids: ids,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },
                success: function(response) {
                    $('#rfq-batch-email-modal').modal('hide');
                },
                error: function(error) {
                    $('#rfq-batch-email-modal').modal('hide');
                }
            });
        });

        // Init the RFQ comments lib
        abcsetup.rfq.comments.init();
        abcsetup.rfq.supply_issues.comments.init();
    },

    /**
     * Yajra datatables have been init - this is the event
     */
    tableDrawCallback: function(table) {
        abcsetup.rfq.common.tableDrawCallback(table);
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  RFQ Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rfq: {
        /**
         *
         */
        pauseEvent: function (id, message = null) {
            abcsetup.dashboard.showLoading($('#rfq_panel'));
            $('#rfq_panel').find('.dataTables_wrapper').hide();

            axios.post('/api/rfq/bid_requests/' + id + '/pause', {message: message}).then(response => {
                window.location.reload();
            });
        },

        deleteEvent: function (id, message = null) {
            abcsetup.dashboard.showLoading($('#rfq_panel'));
            $('#rfq_panel').find('.dataTables_wrapper').hide();

            axios.delete('/rfq/bid_requests/' + id, {data: {message: message}}).then(response => {
                window.location.reload();
            });
        },

        sendRFQBatchEmails: function () {
            abcsetup.dashboard.showLoading($('#rfq_panel'));
            $('#rfq_panel').find('.dataTables_wrapper').hide();

            axios.get('/api/rfq/bid_requests/send_batch_emails').then(response => {
                window.location.reload();
            }).catch(error => {
                alert('Error sending batch emails.');
                window.location.reload();
            });
        },

        quickResolve: function (id) {
            abcsetup.blockUI(true);

            axios.post(`/api/rfq/supply_issues/${id}/quick_resolve`, {})
            .then(response => {
                if (response.data && response.data.success) {
                    abcsetup.unblockUI(false);
                    abcsetup.alerts.show('Success', 'Supply issue marked as resolved successfully.');
                    
                    window.LaravelDataTables['app_data_tables_r_f_q_supplier_issues_summary_data_tableopen'].ajax.reload();
                    window.LaravelDataTables['app_data_tables_r_f_q_supplier_issues_summary_data_tableresolved'].ajax.reload();
                }
            })
            .catch(error => {
                abcsetup.unblockUI();
                console.error(error);
                abcsetup.alerts.show('Something went wrong', 'Something went wrong trying to quickly mark this supply issue as resolved. Reach out to support for more help');
            });
        }
    },
}
